<template>
    <div :class="[{'draggable-padding item-grid' : page_builder_mode}, classes.outer_container]" :style='[custom_styles.outer_container]'>
        <div v-if='page_builder_mode' class='drag-area-text-container'>
            <div class='drag-area-text'>Draggable area</div>
        </div>
        <div class='item-grid carosuel-container' :style='[custom_styles.inner_container]' :class="[classes.inner_container]">
            <div :id='"carosuel_"+element.id' class="swiper mySwiper" v-show='!loading' @mouseenter="mouseEnterCarousel" @mouseleave="mouseLeaveCarousel" :style='[custom_styles.carousel_container]' :class="[classes.carousel_container]">

                <ImageCarousel v-if='element.element_config.config.carousel_type == "image"' :element='element' :page_builder_mode='page_builder_mode' :selected_carousel_slide='selected_carousel_slide' @selectedCarouselTypeListener='selectedCarouselType' />
                <ImageTextCarousel v-if='element.element_config.config.carousel_type == "image_text"' :element='element' :page_builder_mode='page_builder_mode' :selected_carousel_slide='selected_carousel_slide' @selectedCarouselTypeListener='selectedCarouselType' />
                <PopularProductsCarousel v-if='element.element_config.config.carousel_type == "popular_products"' :element='element' :page_builder_mode='page_builder_mode' :selected_carousel_slide='selected_carousel_slide' @selectedCarouselTypeListener='selectedCarouselType' />
                <RecentlyViewedCarousel v-if='element.element_config.config.carousel_type == "recently_viewed_products"' :element='element' :page_builder_mode='page_builder_mode' :selected_carousel_slide='selected_carousel_slide' @selectedCarouselTypeListener='selectedCarouselType' />
                <ProductsCarousel v-if='element.element_config.config.carousel_type == "products"' :element='element' :page_builder_mode='page_builder_mode' :selected_carousel_slide='selected_carousel_slide' @selectedCarouselTypeListener='selectedCarouselType' />

                <div v-show='element.element_config.config.show_navigation_arrows' class="swiper-button-next" :style="[custom_styles.button_next]" :class="[classes.button_next]"></div>
                <div v-show='element.element_config.config.show_navigation_arrows' class="swiper-button-prev"  :style="[custom_styles.button_prev]" :class="[classes.button_prev]"></div>
                <!-- <div v-show='element.element_config.config.show_pagination_dots' class="swiper-pagination" :style='["--dot_colour: " + (typeof element.element_config.styles.dot_color !== "undefined" ? element.element_config.styles.dot_color.value : "#233142"),  custom_styles.page_dots]' :class="[classes.page_dots]"></div> -->

                <div v-show='element.element_config.config.show_pagination_dots' class="swiper-pagination" :style='[custom_styles.page_dots]' :class="[classes.page_dots]"></div>
                
                <div class='empty-carosuel-section' v-if='element.element_config.slides.length == 0 && (element.element_config.config.carousel_type == "image_text" || element.element_config.config.carousel_type == "image") '>
                    <div class='empty-carosuel-text'>
                        Empty Carosuel
                    </div>
                </div>

                <div class='empty-carosuel-section' v-if='number_of_slides == 0 && element.element_config.config.carousel_type != "image_text"'>
                    <div class='empty-carosuel-text'>
                        No products to show
                    </div>
                </div>
            </div>

            <div v-if='loading' class='loading-container'><Loading/></div>
            
        </div>
    </div>
</template>

<script>

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, EffectCards} from 'swiper/modules';
import 'swiper/css/bundle';

import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import ImageTextCarousel from '@/global/components/dynamic_pages/elements/carousel_types/ImageTextCarousel.vue';
import ImageCarousel from '@/global/components/dynamic_pages/elements/carousel_types/ImageCarousel.vue';
import PopularProductsCarousel from '@/global/components/dynamic_pages/elements/carousel_types/PopularProductsCarousel.vue';
import RecentlyViewedCarousel from '@/global/components/dynamic_pages/elements/carousel_types/RecentlyViewedCarousel.vue';
import ProductsCarousel from '@/global/components/dynamic_pages/elements/carousel_types/ProductsCarousel.vue';

import default_carosuel_config from "@/page_builder/builder/default_builder_configs/elements/carousel.json";
import {deepCopyObject} from "@/global/modules/functions.js";
import Loading from '@/ecom/components/loading/Loading.vue';
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {DynamicImageContainer, ImageTextCarousel, PopularProductsCarousel, RecentlyViewedCarousel, ProductsCarousel, Loading, ImageCarousel},
    props: ['element', 'page_builder_mode', 'selected_carousel_slide'],
    mixins: [format_custom_styles],
    data(){
        return{
            swiper: null,
            number_of_slides: 0,
            loading: true,
            classes: {}
        }
    },
    methods:{
        slideClick(slide){
            if(!this.page_builder_mode){
                if(slide.url != ''){
                    this.$router.push(slide.url);
                }
            }
        },
        setAutoPlay(){
             let autoplay = false;

            if(this.element.element_config.config.autoplay){
                autoplay = {
                    delay: this.element.element_config.config.autoplay_delay
                }
            }

            return autoplay;
        },
        mouseEnterCarousel(){
            if(this.element.element_config.config.autoplay && this.element.element_config.config.autoplay_pause_on_mouse_enter){
                this.swiper.autoplay.stop();
            }
        },
        mouseLeaveCarousel(){
             if(this.element.element_config.config.autoplay && this.element.element_config.config.autoplay_pause_on_mouse_enter){
                this.swiper.autoplay.start();
            }
        },
        createCarousel(){
            if(this.swiper != null){
                this.swiper.destroy();
            }

            let autoplay = this.setAutoPlay();

            this.swiper = new Swiper(`#carosuel_${this.element.id}`, {
                modules: [Navigation, Pagination, Autoplay, EffectFade, EffectCards],
                loop: this.element.element_config.config.loop,
                slidesPerView: this.element.element_config.config.slides_per_view,
                spaceBetween: this.element.element_config.config.gap_between_slides,
                centerInsufficientSlides: true,
                watchSlidesVisibility: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                autoplay: autoplay,
                effect: this.element.element_config.config.transition,
                cardsEffect:{
                    slideShadows: false
                },
                fadeEffect: {
                    crossFade: true
                },
            });
        },
        selectedCarouselType(slides){
            this.loadDefaults();
            this.number_of_slides = slides.length;
            this.loading = false;
            this.createCarousel();
        },
        loadDefaults(){
            let current_config = deepCopyObject({...default_carosuel_config.config, ...deepCopyObject(this.element.element_config.config)});
            this.element.element_config.config = current_config;
        },
        updateSwiperInstanceAfterConfigChange(){
            if(this.swiper != null){
                this.createCarousel();
                // this.swiper.params.spaceBetween = this.element.element_config.config.gap_between_slides;
                // this.swiper.params.slidesPerView = this.element.element_config.config.slides_per_view;
                // this.swiper.params.effect = this.element.element_config.config.transition;

                // let autoplay = this.setAutoPlay();
                // if(!autoplay){
                //     this.swiper.autoplay.stop();
                // }
                // else{
                //     this.swiper.autoplay.start();
                // }

                // this.swiper.params.autoplay = autoplay;

                // this.swiper.update();
            }
        },
        setClasses(){
            if(this.element.element_config.compiled_classes != null){
                this.classes = this.element.element_config.compiled_classes;
            }
        },
    },
    mounted(){
        /* Load any additional default configs that are missing */
        this.loadDefaults();
        this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
        this.setClasses();
    },
    watch: {
        'element': {
            handler(){
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
                this.setClasses();
                this.updateSwiperInstanceAfterConfigChange();
            },
            deep: true
        },
        'selected_carousel_slide': function(){
            let index = this.element.element_config.slides.findIndex(x => x.id === this.selected_carousel_slide);
            if (index != -1){
                this.swiper.slideTo(index);
            }
        },
        'element.element_config.config.carousel_type': function(){
            if(this.page_builder_mode){
                this.loading = true;
            }
        }
    }
}
</script>

<style lang="scss">
.draggable-padding{
    // padding: 15px;
    z-index: 0;
    // background: red;
    border: 20px red solid;
    cursor: pointer;
    border-image: repeating-linear-gradient(
      45deg,
      #7380ec20,
     #7380ec20 2px,
      white 2px,
      white 4px
    )
    20;
}
.swiper-pagination-bullet-active {
    // background-color: var(--dot_colour);
    background-color: #233142;
}
.swiper-button-next {
    color: #233142;
}
.swiper-button-prev {
    color: #233142;
}
</style>

<style lang="scss" scoped>
.drag-area-text-container{
    position: absolute;
    top: 0;
}
.drag-area-text{
    background-color: #7380ec60;
    width: 140px;
    font-size: 0.8rem;
    text-align: center;
    border-radius: 5px 5px 0px 0px;
    height: 20px;
    margin: auto;
    font-family: "Poppins", sans-serif;
}

.item-grid {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    z-index: 0;
    justify-content: center;
}
.item-grid > :first-child {
  min-width: 100%;
}

.swiper-slide{
  width: 200px;
  cursor: pointer;
}

.swiper-slide:hover{
    text-decoration: underline;
}

.swiper-wrapper{
    margin-bottom: 30px;
}
.swiper {
  width: 100%;
  height: 100%;
}

.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
}

// .slide-img{
//     width: 200px;
//     height: auto;
// }

// .no-selected-image{
//     text-align: center;
// }

// .no-image-selected-text{
//     padding-top: 30px;
//     font-size: 1rem;
//     color: #495057;
// }

// .slide-text{
//     text-align: center;
//     font-size: 1rem;
//     text-transform: uppercase;
//     // text-decoration: underline;
//     font-weight: 500;
// }

.empty-carosuel-text{
    font-size: 1.2rem;
    color: #868e96;
    text-align: center;
    // margin-top: 75px;
    padding-top: 75px;
}
.empty-carosuel-section{
    height: 200px;
}
</style>